
import { fetch as fetchPolyfill } from 'whatwg-fetch';

import { loadWidget } from '../utils/load-widget';
import { getCookie } from '../../utils/cookie-handler';

const COOKIE_NAME = '_bo_active_promo_code';
const COOKIE_EXPIRY = '_bo_promo_expire_date';

loadWidget('promo-code-banner', {
        data: () => ({
            ViewModel: {
                Loading: true,
                PromoCode: false,
                Removing: false,
            }
        }),
        methods: {
            init() {
                const promoCode = getCookie(COOKIE_NAME);

                if (String(promoCode) !== 'undefined' && String(promoCode) !== 'null' && String(promoCode).length) {
                    this.ViewModel.PromoCode = promoCode;
                    this.checkAutoRemovalTime();
                }

                setTimeout(() => {
                    this.ViewModel.Loading = false;
                }, 10);
            },
            checkAutoRemovalTime() {
                const expiryTime = parseInt(getCookie(COOKIE_EXPIRY), 10) * 1000;
                if (expiryTime) {
                    const expiryTimeout = expiryTime - (new Date());
                    setTimeout(() => {
                        this.remove(true);
                    }, expiryTimeout);
                }
            },
            remove(autoRemoval) {
                this.ViewModel.Removing = true;

                const url = `${window.AppConfig.bo_url}/api/promocode/remove`.replace('//api/', '/api/');

                const request = {
                    method: 'GET',
                    credentials: 'include',
                };

                fetchPolyfill(url, request).then(response => {
                    return response.json();
                }).then(response => {
                    if (response.status === 'ok') {
                        if (autoRemoval) {
                            alert('Your promo code has expired');
                        }
                        window.location.reload();
                    } else {
                        alert('There was a problem removing the promo code. Please try again.');
                    }
                }).catch(() => {
                    alert('There was a problem removing the promo code. Please try again.');
                }).finally(() => {
                    this.ViewModel.Removing = false;
                });
            },
        },
        beforeMount() {
            this.init();
        },
});
